import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult, serializeQueryString} from '../../shared';
import {Company} from '../models/company';
import {ContractFilter} from '../../contract/models/contract-filter';
import {SubscriptionsList} from '../../shared/models/subscription';
import {TriggerInvoices} from '../../invoices/models/invoices';
import {LanguageText} from '../../contract/models/language-text';
import {CancelOrder} from '../../order/models/cancel-order';
import {Order} from '../../order/models/order';

@Injectable({providedIn: 'root'})
export class CompanyService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'CompanyService'; }

  protected get isAnonymous(): boolean { return false; }

  load(uuid: string): Observable<SendBackResult<Company>> {
    return this.get<Company>(`/company/${uuid}`);
  }
  getList(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    return this.get<ArrayResponse<SubscriptionsList>>(`/company/${uuid}/Subscriptions${serializeQueryString(filter)}`);
  }
  // tslint:disable-next-line:no-any
  update( data: any , api: string , companyUuid: string): Observable<SendBackResult<ArrayResponse<any>>>  {
    switch (api) {
      case 'general':
        // tslint:disable-next-line:no-any
        return this.post<ArrayResponse<any>>(`/company/${companyUuid}`,   data );
        break;
      case 'billing':
        // tslint:disable-next-line:no-any
        return this.post<ArrayResponse<any>>(`/company/${companyUuid}`,   data   );
        break;
      case 'simple':
        // tslint:disable-next-line:no-any
        return this.patch<ArrayResponse<any>>(`/company`, { companyUuid: companyUuid , company: data } );
        break;
      case 'address':
        // tslint:disable-next-line:no-any
        return this.patch<ArrayResponse<any>>(`/company/${companyUuid}/address`,  data  );
        break;
      case 'contact':
        // tslint:disable-next-line:no-any
        return this.patch<ArrayResponse<any>>(`/company/${companyUuid}/contact`,  data  );
        break;
    }

  }

  // tslint:disable-next-line:variable-name no-any
  deleteCompany(Uuid: string): Observable<any> {
    // tslint:disable-next-line:no-any
    return this.post<any>(`/company/${Uuid}/delete`, null);
  }

  add(company: Company): Observable<SendBackResult<Company>> {
    return this.post<Company>(`/company`, company); // TODO: add type  modif dto)
  }

  // tslint:disable-next-line:no-any
  getPreview(data: any): any {
    return this.post(`/billings/invoices/preview`, data );
  }
  // tslint:disable-next-line:no-any
  getAlreadyInvoicePreview(data: any): any {
    return this.post(`/billings/already/invoices/preview`, data );
  }
}
